import React from 'react'
import ReactDOM from 'react-dom/client'

import '@fontsource/roboto/300.css'
import '@fontsource/roboto/400.css'
import '@fontsource/roboto/500.css'
import '@fontsource/roboto/700.css'

import '@/fonts.css'
import '@/style.css'
import App from './App'
import Router from './router'

import { createTheme, ThemeProvider } from '@mui/material/styles'
import { PocketbaseUserProvider } from './pb'

const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      light: '#dcff90',
      main: '#cdff65',
      dark: '#9dd328',
      contrastText: '#121212',
    },
    secondary: {
      light: '#cf998b',
      main: '#c3806e',
      dark: '#88594d',
      contrastText: '#121212',
    },

    background: {
      default: '#121212', // page background
      paper: '#1e1e1e',   // cards, surfaces
    },

    text: {
      primary: '#ffffff',
      secondary: '#b0b0b0',
    },
  },
})

ReactDOM.createRoot(document.querySelector('#app')).render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <PocketbaseUserProvider>
        <Router />
      </PocketbaseUserProvider>
    </ThemeProvider>
  </React.StrictMode>
  ,
)

import {timesync} from './api'

timesync()